/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 15:26:57
 * @LastEditTime: 2019-09-02 17:59:53
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios';
import qs from 'qs';
import route from '@/router.js'
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器
// axios.defaults.baseURL = process.env.VUE_APP_URL
// axios.defaults.baseURL = process.env.VUE_APP_URL    
// var apis = {
//     login: 'https://login.tx315.vip/api/v1',
//     logistics: "https://dealer.tx315.vip/api/v1",
//     logistics_1: 'https://dealer.tx315.vip/dealer/v1',
//     logistics_2: 'https://pps.tx315.vip/index.php/',
//     conf: 'https://logistics.tx315.vip/admin/v2',
//     oem: 'https://dealer.tx315.vip/pay/v1',
//     webUrl: 'https://jifen.tx315.vip/',
//     dealer_pc: 'https://yxfk.tx315.vip/index.php/'
// };

var apis
if(process.env.NODE_ENV=='development'){
    apis = {
        login: 'https://login.tx315.vip/api/v1',
        logistics: "http://dewl.com/index.php/api/v1",
        logistics_1: 'http://dewl.com/index.php/dealer/v1',
        logistics_2: 'http://pps.qwe.com/index.php/',
        conf: 'https://logistics.tx315.vip/admin/v2',
        oem: 'https://dewl.com/index.php/pay/v1',
        webUrl: 'https://jifen.tx315.vip/',
        dealer_pc: 'https://yxfk.tx315.vip/index.php/'
    };
}else{
    apis = {
        login: 'https://login.tx315.vip/api/v1',
        logistics: "https://dealer.tx315.vip/api/v1",
        logistics_1: 'https://dealer.tx315.vip/dealer/v1',
        logistics_2: 'https://pps.tx315.vip/index.php/',
        conf: 'https://logistics.tx315.vip/admin/v2',
        oem: 'https://dealer.tx315.vip/pay/v1',
        webUrl: 'https://jifen.tx315.vip/',
        dealer_pc: 'https://yxfk.tx315.vip/index.php/'
    };
}


export default apis
// apis={
//     login:'http://login.c.smartcode.vip/api/v1',
//     logistics:'http://dealer.c.smartcode.vip/api/v1',
//     logistics_1:'http://dealer.c.smartcode.vip/dealer/v1',
//     logistics_2:'http://pps.cs.c.smartcode.vip/index.php/',
//     oem:'https://dealer.c.smartcode.vip/pay/v1',
//     dealer_pc:'http://dealer.c.smartcode.vip/index.php/',
//     local:"http://jxspps.cs.com/index.php",
//     conf:'http://logistics.c.smartcode.vip/admin/v2'
// }
axios.interceptors.request.use(
    config => {
        config.data = qs.stringify(config.data);
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accept': 'application/json',
        }
        if (localStorage.getItem('access_token')) {
            config.headers.Authorization = 'Bearer' + " " + localStorage.getItem('access_token');
        }

        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code == 100) {
            location.href = location.href.split('#/')[0] + '#/login';//跳回登陆页面
        }
        return response;
    },
    error => {
        if (error.response.data) {
            return Promise.reject(error.response.data)

        }
    }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(module, url, params = {}) {
    var baseUrl = ''

    if (module === 'login') {
        baseUrl = apis.login + url
    } else if (module == 'logistics') {
        baseUrl = apis.logistics + url

    } else if (module == 'logistics_1') {
        baseUrl = apis.logistics_1 + url
    } else if (module == 'conf') {

        baseUrl = apis.conf + url
    } else if (module == 'oem') {

        baseUrl = apis.oem + url
    }
    else if (module == 'dealer_pc') {

        baseUrl = apis.dealer_pc + url
    }
    else if (module == 'local') {

        baseUrl = apis.local + url
    }

    else {
        baseUrl = apis.logistics_2 + url
    }
    return new Promise((resolve, reject) => {

        axios.get(baseUrl, {
            params: params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module, url, data = {}) {

    var baseUrl = ''
    if (module === 'login') {
        baseUrl = apis.login + url
    } else if (module == 'logistics') {
        baseUrl = apis.logistics + url

    } else if (module == 'logistics_1') {
        baseUrl = apis.logistics_1 + url
    } else if (module == 'conf') {

        baseUrl = apis.conf + url
    } else if (module == 'oem') {

        baseUrl = apis.oem + url
    } else if (module == 'dealer_pc') {

        baseUrl = apis.dealer_pc + url
    } else if (module == 'local') {

        baseUrl = apis.local + url
    }
    else {
        baseUrl = apis.logistics_2 + url
    }
    return new Promise((resolve, reject) => {
        axios.post(baseUrl, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module, url, data = {}) {

    var baseUrl = ''
    if (module === 'login') {
        baseUrl = apis.login + url
    } else if (module == 'logistics') {
        baseUrl = apis.logistics + url

    } else if (module == 'logistics_1') {
        baseUrl = apis.logistics_1 + url
    } else if (module == 'conf') {

        baseUrl = apis.conf + url
    } else if (module == 'oem') {

        baseUrl = apis.oem + url
    } else if (module == 'dealer_pc') {

        baseUrl = apis.dealer_pc + url
    } else if (module == 'local') {

        baseUrl = apis.local + url
    }
    else {
        baseUrl = apis.logistics_2 + url
    }
    return new Promise((resolve, reject) => {
        axios.patch(baseUrl, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module, url, data = {}) {
    var baseUrl = ''
    if (module === 'login') {
        baseUrl = apis.login + url
    } else if (module == 'logistics') {
        baseUrl = apis.logistics + url

    } else if (module == 'logistics_1') {
        baseUrl = apis.logistics_1 + url
    } else if (module == 'conf') {

        baseUrl = apis.conf + url
    } else if (module == 'oem') {

        baseUrl = apis.oem + url
    } else if (module == 'dealer_pc') {

        baseUrl = apis.dealer_pc + url
    } else if (module == 'local') {

        baseUrl = apis.local + url
    }
    else {
        baseUrl = apis.logistics_2 + url
    }
    return new Promise((resolve, reject) => {
        axios.put(baseUrl, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module, url, data = {}) {
    var baseUrl = ''
    if (module === 'login') {
        baseUrl = apis.login + url
    } else if (module == 'logistics') {
        baseUrl = apis.logistics + url

    } else if (module == 'logistics_1') {
        baseUrl = apis.logistics_1 + url
    } else if (module == 'conf') {

        baseUrl = apis.conf + url
    } else if (module == 'oem') {

        baseUrl = apis.oem + url
    } else if (module == 'dealer_pc') {

        baseUrl = apis.dealer_pc + url
    } else if (module == 'local') {

        baseUrl = apis.local + url
    }
    else {
        baseUrl = apis.logistics_2 + url
    }
    return new Promise((resolve, reject) => {
        axios.delete(baseUrl, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

